//================================================================
//  Page: Inventory
//================================================================

//  Purpose: This page shows all tables contained within inventory

//  Example:
//    <Inventory></Inventory>    

//================================================================


// Libraries
import React from 'react';

// Contexts

// Components
import PageComponent from '../../Components/PageComponent/PageComponent';
import TabView from '../../Components/TabView/TabView';

// Tabs
import Agreements from './Tabs/Agreements';
import ApplicationsTab from './Tabs/Applications';
import Vendors from './Tabs/Vendors';
import Subnets from './Tabs/Subnets';

// Functions

// Images

// CSS
import './Inventory.css';


export default function Inventory() {

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      body={
        <TabView
          defaultView={1}

          //------------------------------------------------------
          // Agreements
          //------------------------------------------------------

          oneTitle={'Agreements'}
          oneRoute={`/inventory?view=agreements`}
          oneContent={
            <Agreements></Agreements>
          }

          //------------------------------------------------------
          // Applications
          //------------------------------------------------------

          twoTitle={'Applications'}
          twoRoute={`/inventory?view=applications`}
          twoContent={
            <ApplicationsTab></ApplicationsTab>
          }

          //------------------------------------------------------
          // Vendors​
          //------------------------------------------------------

          threeTitle={'Vendors'}
          threeRoute={`/inventory?view=vendors`}
          threeContent={
            <Vendors></Vendors>
          }

          //------------------------------------------------------
          // IPAM (Subnets) 
          //------------------------------------------------------

          fourTitle={'IPAM (Subnets)'}
          fourRoute={`/inventory?view=subnets`}
          fourContent={
            <Subnets></Subnets>
          }

        ></TabView>
      }
    ></PageComponent>
  )
}
